<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/kxIhjC/tc-custom/9780253013668.jpg?1706683676986" alt="This image is the cover for the book Russia and the Golden Horde, Encounters: Explorations in Folklore and Ethnomusicology"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Russia and the Golden Horde, Encounters: Explorations in Folklore and Ethnomusicology
      </h1>
      <p class="bookDescription body article font2">
        <b>This revelatory study of Russian medieval history and the age of Mongolian conquest “infuses the subject with fresh insights and interpretations” (<i>History</i>).</b><br/>  <br/> In the 13th century, a Mongolian confederation known as The Golden Horde dominated a vast region including Russia, Ukraine, Kazakhstan, and the Caucuses. Though it would hold power into the 15th century, the influence of the Mongolian Empire on Russian history and culture has been all but ignored. Only in recent years have historians, archeologists, and philologists started to shed much needed light on this significant period of Mongol rule.<br/>  <br/> In this enlightening new study, historian Charles Halperin assesses these recent findings to provide a comprehensive view of this chapter in Russian medieval history, offering a new interpretation of what role the Mongols played in the story of Russia.<br/>  <br/><b>A Selection of the History Book Club</b><br/><br/><b>“Combining rigorous analysis of the major scholarly findings with his own research, Halperin has produced both a much-needed synthesis and an important original work." –<i>Library Journal</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Charles J. Halperin
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Indiana University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1eabfa4f